import { SearchWidget } from '../../components/SearchWidget';
import { I18nProvider } from '../../i18n/I18nContext';
import { useAdminLang } from '../AdminLangContext';

export default function AdminSearchPreview() {
  const { lang } = useAdminLang();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Search Preview</h1>
        <p className="text-muted-foreground">
          Live preview of the search widget as configured
        </p>
      </div>
      <div className="max-w-2xl">
        <I18nProvider lang={lang}>
          <SearchWidget lang={lang} />
        </I18nProvider>
      </div>
    </div>
  );
}
